import { defineFcm } from '../shared/factory';

export const FCM_FUTURE_SAP_MARKETING_CONSENT_REQUIRED = defineFcm('future_sap_marketing_consent_required')
	.asBoolean()
	.withDefault(false)
	.toConfig();
